import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Icon, Popover } from 'antd';
import classNames from 'classnames';
import { activityItemContent, groupItemContent } from 'library/helpers';

const MOUSE_ENTER_DELAY = 0.885;

const mapStateToProps = state => ({
  inFlight: state.api.userAccount.inFlight,
  user: state.api.userAccount.data,
  userTags: state.api.userItemTags.data.results
});

const GroupRenderer = ({
  data,
  inFlight,
  isActive,
  isClickable,
  isDraggable,
  isPinned,
  isUser,
  mouseEnterDelay,
  onDragDrop,
  onDragStart,
  onChangeCallback,
  onClick,
  onDelete,
  onPin,
  rowIndex,
  showDelete,
  showPin,
  title,
  user,
  userTags,
  canHover,
  timelineExtras,
}) => {
  /**
   * @description Handle Popover visibility
   */
  const [visible, handleVisibleChange] = useState(false);
  const wrapperClass = classNames('rct9k-group-item', { 'rct9k-group-item-inactive': !isActive }, { 'rct9k-group-item-draggable': isDraggable });
  const contentWrapper = classNames('title', { 'rct9k-group-item-clickable': isClickable });
  return (
    <div
      className={wrapperClass}
      draggable={isDraggable}
      onDragStart={e => (isDraggable ? onDragStart(e, data) : null)}
      onDragOver={e => e.preventDefault()}
      onDrop={e => (isDraggable ? onDragDrop(e, data) : null)}
    >
      <div className="index">{rowIndex}</div>
      <div
        className={contentWrapper}
        onClick={() => (isClickable ? onClick(data) : null)}
      >
        <Popover
          content={isUser ? groupItemContent({
            ...data,
            tags: userTags,
            ...user
          }, inFlight) : activityItemContent(data)}
          mouseEnterDelay={mouseEnterDelay || MOUSE_ENTER_DELAY}
          onVisibleChange={(e) => {
            handleVisibleChange(e);
            onChangeCallback(data, e);
          }}
          overlayClassName="bhp-timeline-popover"
          placement="right"
          title={title}
          trigger="hover"
          visible={canHover && visible}
        >
          <span onMouseUp={() => handleVisibleChange(false)} onMouseDown={() => handleVisibleChange(true)}>
            {title}
          </span>
        </Popover>
      </div>
      <div className="commands">
        {showDelete && (
          <span className="trash-alt" onClick={() => onDelete(data)}>
            <Icon type="delete" theme="filled" />
          </span>
        )}
        {showPin && (
          <span className="thumbtack" onClick={() => onPin(data)}>
            <Icon type="pushpin" theme="filled" className={classNames({ 'is-pinned': isPinned })} />
          </span>
        )}
      </div>
      {timelineExtras}
    </div>
  );
};

GroupRenderer.propTypes = {
  data: PropTypes.object.isRequired, // The group object to render
  isActive: PropTypes.bool,
  isClickable: PropTypes.bool,
  isDraggable: PropTypes.bool,
  isPinned: PropTypes.bool,
  mouseEnterDelay: PropTypes.number,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  onDragDrop: PropTypes.func,
  onDragStart: PropTypes.func,
  onChangeCallback: PropTypes.func,
  onPin: PropTypes.func,
  rowIndex: PropTypes.string,
  showDelete: PropTypes.bool,
  showPin: PropTypes.bool,
  title: PropTypes.string,
  user: PropTypes.object,
  inFlight: PropTypes.bool,
  isUser: PropTypes.bool,
  userTags: PropTypes.array,
  canHover: PropTypes.bool,
  timelineExtras: PropTypes.node,
};

GroupRenderer.defaultProps = {
  isActive: true,
  isClickable: true,
  isDraggable: true,
  isPinned: false,
  mouseEnterDelay: 0,
  onChangeCallback() {
  },
  onClick() {
  },
  onDelete() {
  },
  onDragDrop() {
  },
  onDragStart() {
  },
  onPin() {
  },
  rowIndex: '0',
  showDelete: true,
  showPin: false,
  title: '',
  user: {},
  inFlight: false,
  isUser: false,
  canHover: true,
  userTags: [],
  timelineExtras: null,
};

export default connect(mapStateToProps)(GroupRenderer);
